import { InputHTMLAttributes, DetailedHTMLProps } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
interface ITextInputHookForm
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  name?: string;
  className?: string;
  label?: string;
  register?: UseFormRegisterReturn;
  validation?: any;
  ref?: any;
  required?: boolean;
}
const TextInputHookFormDisabled: React.FC<ITextInputHookForm> = ({
  type = "text",
  className,
  name,
  register,
  validation,
  ref,
  disabled,
  required = false,
  ...props
}) => {
  return (
    <div className="space-y-1 w-full text-xs">
      <div
        className={`grid grid-cols-1 md:grid-cols-3 w-full items-center gap-2 col-span-2`}
      >
        {props.label && (
          <label className="flex space-x-1 justify-start expandedLabel fontExpand">
            {required && <div className="text-red-500 pr-0.5 font-bold">*</div>}{" "}
            {props.label}:
          </label>
        )}
        <input
          className={`${className} col-span-2 w-full px-1 py-1 text-xs sm:text-xs rounded-sm bg-white`}
          {...register}
          disabled={true}
          required={required}
          {...props}
        />
      </div>
    </div>
  );
};
export default TextInputHookFormDisabled;
